export * from '../src/components/wui-icon/index.js';
//# sourceMappingURL=wui-icon.js.map